// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_26l--","smallLinkTypography":"_2C0zv","titleTypography":"_1TMHm","cardTitleTypography":"x56l4","truncate":"_4UFnc","base":"_3X_zC","sectionTopHeader":"_2Vp_7","section":"_3gYgD","sectionTitle":"_3gVWn","sectionContent":"_2pTIl","sectionLoading":"_29n3j","sectionFooter":"_3rncL","linkButton":"_3s5rs","button":"jY-XE","tip":"TrKzh","panel":"_3BzbH","export":"_7Yf5E","exportReminder":"_3dzr-","pagination":"_3QlaC","uploadSection":"_2xkA0","reminderNotificationSection":"_1lQko","footer":"_1VpV-"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerReports/PartnerPlan/PartnerPlans.scss
// module id = 2698
// module chunks = 0